module.exports = __webpack_public_path__ + "assets/img/thumb-SpinTel-Pillar-Page-Resource.ef7d3cc8.jpg";